import React, { createContext, useContext, useState } from "react";

import Logger from "../utils/logger";

const log = Logger.create("MapViewContext");

// context 생성
const MapViewContext = createContext();

// provider 정의
export function MapViewProvider({ children }) {
  const [showMap, setShowMap] = useState(false);
  return (
    <MapViewContext.Provider value={{ showMap, setShowMap }}>
      {children}
    </MapViewContext.Provider>
  );
}

// context 사용 훅
export function useMapView() {
  return useContext(MapViewContext);
}
